<template>
  <div>
    <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="formInline.nameOrCode" clearable @keyup.enter.native="onSearch" placeholder="商务供应商名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select filterable v-model="formInline.businessPrincipalId" clearable placeholder="请选择供应商负责人">
          <el-option 
            v-for="(item,index) in businessPrincipalList" 
            :key="index" 
            :label="item.username" 
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.supplierType" clearable placeholder="请选择供应商类型">
          <el-option label="公司" :value="1"></el-option>
          <el-option label="个人" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.status" clearable placeholder="请选择供应商状态">
          <el-option label="审批中" :value="0"></el-option>
          <el-option label="审批通过" :value="1"></el-option>
          <el-option label="审批不通过" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">商务供应商总数：{{total}}条</div>
    <el-table size="small" :data="tableData" style="width: 100%">
      <el-table-column prop="code" align="center" label="商务供应商编号"></el-table-column>
      <el-table-column prop="name" align="center" label="商务供应商名称"></el-table-column>
      <el-table-column prop="supplierType" align="center" label="供应商类型">
        <template slot-scope="scope">
          <div>{{scope.row.supplierType == 1?"公司":scope.row.supplierType == 2?"个人":""}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="businessPrincipalNames" align="center" label="供应商负责人"></el-table-column>
      <el-table-column prop="status" align="center" label="供应商状态">
        <template slot-scope="scope">
          <div>{{scope.row.status == 0?"审批中":scope.row.status == 1?"审批通过":"审批不通过"}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button type="text" size="small" @click='goUrl(scope.row.id)'>编辑</el-button>
            <el-button size="small" type="text" @click="approvalDeatilClick(scope.row.id,1)">审批详情</el-button>
          </div>
          <div v-if="scope.row.status == 1">
            <el-button type="text" size="small" @click='goUrl(scope.row.id)'>编辑</el-button>
          </div>
          <div v-if="scope.row.status == 2">
            <el-button type="text" size="small" @click='goUrl(scope.row.id)'>重新提交</el-button>
            <el-button type="text" size="small" @click='approvalDeatilClick(scope.row.notPassReason,2)'>原因</el-button>           
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap">
      <el-pagination background @size-change="sizeChange" @current-change="currentChange"
        :current-page.sync="formInline.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="approvalDialog"
      width="30%">
      <!-- 启动审批详情,盖章审批详情-->
      <div v-if="notPassReason">{{notPassReason}}</div>
      <div v-else>
        <div v-if="finalApproval.auditStatus == 11 || finalApproval.auditStatus==12">
          <div v-if="finalApproval.staff4NameList" style="padding-top:2px;">
            (四级可审批人：
            <span v-for="(item,index) in finalApproval.staff4NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 13 || finalApproval.auditStatus==14">
          <div>四级审批人：{{finalApproval.staff4Name}}</div>
          <div v-if="finalApproval.staff3NameList" style="padding-top:2px;">
            (三级可审批人：
            <span v-for="(item,index) in finalApproval.staff3NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 15 || finalApproval.auditStatus==16">
          <div>三级审批人：{{finalApproval.staff3Name}}</div>
          <div v-if="finalApproval.staff2NameList" style="padding-top:2px;">
            (二级可审批人：
            <span v-for="(item,index) in finalApproval.staff2NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApproval.auditStatus == 17 || finalApproval.auditStatus==18">
          <div>二级审批人：{{finalApproval.staff2Name}}</div>
          <div v-if="finalApproval.staff1NameList" style="padding-top:2px;">
            (一级可审批人：
            <span v-for="(item,index) in finalApproval.staff1NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        

        <div v-if="finalApproval.auditStatus == 3 || finalApproval.auditStatus == 4">
          <div>业务总监审批人：{{finalApproval.chiefName}}</div>
          <div v-if="finalApproval.chiefNameList" style="padding-top:2px;">
            (业务总监可审批人：
            <span v-for="(item,index) in finalApproval.chiefNameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <!-- 1-待直属主管审批；2-直属主管审批不通过；3-待业务总监审批；4-业务总监审批不通过；5-审批通过 -->
        <div style="padding:10px 0;">
          审批状态：{{auditStatusList[finalApproval.auditStatus]}}
        </div>
        <div>审批备注：{{finalApproval.auditRemark}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAdmin } from "@/api/business/contract";
import { supplierBusinessList, supplierBusinessAuditDetail } from "../index";
export default {
  data() {
    return {
      auditStatusList:['','待直属主管审批','直属主管审批不通过','待业务总监审批','业务总监审批不通过','审批通过' ],
      total:0,
      formInline: {
        businessPrincipalId:"",
        nameOrCode:"",
        status:"",
        supplierType:"",
        pageNum: 1,
				pageSize: 10,
      },
      tableData: [],
      businessPrincipalList:[],
      dialogTitle:"",
      approvalDialog:false,
      finalApproval:{},
      notPassReason:"",
    };
  },
  computed: {
  },
  mounted() {
    this.getList();
    listAdmin({
      pageSize: 99999,
      pageNum: 1
    }).then(res=>{
      this.businessPrincipalList = res.data
      console.log('====数据=====',res)
    })
  },
  methods: {
    //启动审批详情
    async approvalDeatilClick(id,type){
      this.notPassReason = '';
      if(type == 1){
        this.finalApproval = await this.getAuditDetail(id);
        this.dialogTitle = '商务供应商审批详情'
        this.approvalDialog = true
      }else{
        this.dialogTitle = '审批不通过原因'
        this.approvalDialog = true;
        this.notPassReason = id;
      }
    },
    async getAuditDetail(id){
      let res = await supplierBusinessAuditDetail({id});
      console.log('=====审批详情=====',res)
      return res.data
    },
    getList(){
      supplierBusinessList(this.formInline).then((res) => {
        if(res.code == 1){
          this.tableData = res.data;
          this.total = res.total;
          console.log('=====列表数据=====',res)
        }
      }).catch((err) => {
        
      });
    },
    onSearch(){
      this.getList();
    },
    goUrl(id){
      let router = this.$router.push({
        path: "/businessManagement/business/edit",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.formInline.pageNum = 1;
      this.formInline.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.formInline.pageNum = val;
      this.getList();
    },
  },
};
</script>